import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ErrorFilled } from '@one-thd/sui-icons';

import '../../styles/business-tools.scss';

export const BusinessToolsErrorMessage = () => {
  return (
    <div className="sui-flex sui-text-danger business-tools__marginTop">
      <div className="sui-self-center" style={{ paddingRight: 5 }}>
        <ErrorFilled color="danger" />
      </div>
      <Typography variant="body-lg"> </Typography>
      <Typography variant="body-base">
        <span className="">We&apos;re Sorry!</span>
        There was a temporary technical error displaying this information.
        Please try refreshing the page.
      </Typography>
    </div>
  );
};
